module.exports = __webpack_public_path__ + "static/media/stamp.38a5e3f8.png";